//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cusDateTime from '@/components/cusDateTime';
export default {
  name: "assessment-view",
  props: ['dataId', 'dataImg','isEdit'],
  components:{cusDateTime},
  data() {
    return {
      isSupplier:false,
      replyList:[
        {
          code:true,
          value:'同意'
        },{
          code:false,
          value:'拒绝'
        }
      ],
      orderDto: {},
      gridList: [
        {icon: require('@/assets/icon/supplier/supplier_base_data.png'), label: '基本信息'},
        {icon: require('@/assets/icon/supplier/bidding_detail.png'), label: '订单明细'},
        {icon: require('@/assets/icon/supplier/com_order_details.png'), label: '收货地址'},
        {icon: require('@/assets/icon/supplier/com_order_flow.png'), label: '流程信息'},
      ],
      index: 1,
    }
  },
  methods: {
    valid(){
      if(this.orderDto.requestBase && this.orderDto.requestBase.workflowNodeBase && this.orderDto.requestBase.workflowNodeBase.nodeType === 'userTask' && this.isSupplier){
        if(!(this.orderDto.supplierReply || this.orderDto.supplierReply === false)){
          this.$vux.toast.text('请在基本信息中选择回复意见');
          return false;
        }
      }
      return true;
    },
    formData() {
      return this.orderDto;
    },
    changeCellShow(list, i) {
      if (list[i].cellShow) {
        this.$set(list[i], 'cellShow', false);
        return;
      }
      this.$set(list[i], 'cellShow', true);
    },
    itemTab(index) {
      this.index = index;
      if(index === 4){
        this.$emit('changeFlowInfo',true);
      }else{
        this.$emit('changeFlowInfo',false);
      }
    },
    getOrderDto() {
      this.$loadingShow();
      this.$get('api/purOrder/' + this.dataId).then((data) => {
        if (data) {
          this.orderDto = data;
          this.orderDto.orderDetails.map(i=>{
            i.pretaxPrice = +(i.pretaxPrice.toFixed(2))
          })
        }
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    changeOrd(orderDetail) {
      if (orderDetail.show) {
        this.$set(orderDetail, 'show', false);
        return;
      }
      this.$set(orderDetail, 'show', true);
    },
    switchTabItem(e, info) {
      e['list'] = info;
      this.$forceUpdate();
    },
    getPerson(){
      this.$get('api/person/current').then((res) => {
        if(res.userType === '0'){
          this.isSupplier = true;
        }else{
          this.isSupplier = false;
        }
      })
    }
  },
  mounted() {
    this.getPerson();
    if (this.dataId) {
      this.getOrderDto();
    }
  },
  watch: {
    dataId() {
      if (this.dataId) {
        this.getOrderDto();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/purchase-order/purchase-order-check.vue